import React from 'react';
import { withTranslation } from 'react-i18next';
import {
  FormGroup,
  Label,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { DropdownButton } from '../DropdownBtn';
import Required from '../Required';
import DatePicker from 'react-datepicker';
import Moment from 'moment';

const dropdownItemStyle = { boxSizing: 'border-box' };

const TimeSelector = ({ t, ...props }) => {
  const options = [
    { name: t('User-Specified Date and Time'), value: 0 },
    { name: t('Previous 8 Hours'), value: 1 },
    { name: t('Previous 24 Hours'), value: 2 },
    { name: t('Today'), value: 3 },
    { name: t('This week to Date'), value: 4 },
    { name: t('Previous 7 Days'), value: 5 },
    { name: t('Previous 14 Days'), value: 6 },
    { name: t('This Month'), value: 7 },
  ];
  const [option, setOption] = React.useState(options[7].value);
  const [text, setText] = React.useState(options[7].name);
  const [state, setState] = React.useState({
    from: Moment().startOf('month').toDate(),
    to: Moment().toDate(),
  });
  const [isCustom, setFlagIsCustom] = React.useState(false);

  React.useEffect(() => {
    let { from, to } = state;
    switch (option) {
      case 1:
        from = Moment().subtract(8, 'hours').toDate();
        to = Moment().toDate();
        break;
      case 2:
        from = Moment().subtract(24, 'hours').toDate();
        to = Moment().toDate();
        break;
      case 3:
        from = Moment().startOf('date').toDate();
        to = Moment().endOf('date').toDate();
        break;
      case 4:
        from = Moment().startOf('week').toDate();
        to = Moment().toDate();
        break;
      case 5:
        from = Moment().subtract(7, 'days').toDate();
        to = Moment().toDate();
        break;
      case 6:
        from = Moment().subtract(14, 'days').toDate();
        to = Moment().toDate();
        break;
      case 7:
        from = Moment().startOf('month').toDate();
        to = Moment().toDate();
        break;
      default:
        from = props.onlyHour
          ? Moment().toDate().setMinutes(0, 0)
          : Moment().toDate();
        to = props.onlyHour
          ? Moment().toDate().setMinutes(0, 0)
          : Moment().toDate();
        break;
    }
    setState({ ...state, from, to });
    // props.onChange(from, to);
  }, [option]);
  React.useEffect(() => {
    const _to = isCustom
      ? Moment(Moment(state.to).toDate().setMinutes(59, 59)).toDate()
      : state.to;
    props.onChange(state.from, _to);
  }, [state.from, state.to]);
  return (
    <>
      <FormGroup>
        <Label>{t('Time selector')}</Label>
        <DropdownButton id="predefinedTimeDropdown">
          <DropdownToggle
            caret
            id="predefinedTime"
            color="secondary"
            className="w-100"
            defaultValue={option}
          >
            {t(text)}
          </DropdownToggle>
          <DropdownMenu>
            {options.map((option, index) => (
              <React.Fragment key={option.value}>
                <DropdownItem
                  value={`${option.value}`}
                  style={dropdownItemStyle}
                  onClick={() => {
                    setFlagIsCustom(option.value ? false : true);
                    setOption(option.value);
                    setText(option.name);
                  }}
                >
                  {option.name}
                </DropdownItem>
                {index + 1 !== options.length && <DropdownItem divider />}
              </React.Fragment>
            ))}
          </DropdownMenu>
        </DropdownButton>
      </FormGroup>
      {!option && (
        <div>
          <FormGroup className="d-inline-block mr-2">
            <Label htmlFor="fromDate">
              {t('From Date')} <Required />
            </Label>
            <DatePicker
              id="fromDate"
              autoComplete="off"
              className="form-control"
              selected={state.from}
              onChange={(date) => {
                setState({ ...state, from: date });
              }}
              showTimeSelect
              timeIntervals={props.onlyHour ? 60 : 15}
              timeCaption="Time"
              dateFormat="MM/dd/yyyy HH:mm"
              popperClassName="z-99"
            />
          </FormGroup>
          <FormGroup className="d-inline-block">
            <Label htmlFor="toDate">
              {t('To Date')} <Required />
            </Label>
            <DatePicker
              id="toDate"
              autoComplete="off"
              className="form-control"
              selected={state.to}
              onChange={(date) => {
                setState({ ...state, to: date });
              }}
              showTimeSelect
              timeIntervals={props.onlyHour ? 60 : 15}
              timeCaption="Time"
              dateFormat="MM/dd/yyyy HH:mm"
              popperClassName="z-99"
            />
          </FormGroup>
        </div>
      )}
    </>
  );
};

export default withTranslation('app')(TimeSelector);
